import { render, staticRenderFns } from "./RegisterItem.vue?vue&type=template&id=db99ed90&scoped=true&"
import script from "./RegisterItem.vue?vue&type=script&lang=js&"
export * from "./RegisterItem.vue?vue&type=script&lang=js&"
import style0 from "./RegisterItem.vue?vue&type=style&index=0&id=db99ed90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db99ed90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCardText,VSnackbar})
